import React from "react";
import { BEGIN_MEMBER_SCORE_TARGET, CHALLENGE } from "../../../../common/challengeConstants";
import { ProgressBar } from "../../../../common";
import ChallengeProfileImage from "../../../../common/challenge/profileImageContainer/ChallengeProfileImage";
import './TeamBeginMemberCard.scss';

const TeamBeginMemberCard = ({
    userName,
    userId,
    pictureUrl,
    isLeader,
    healthspanScore,
    scoreEarned,
    scoreTarget,
    remainingScore
}) => {

    // no userId/userName -> render as an empty/vacant team slot
    const isVacant = !userId && !userName;

    const renderCardDescription = () => {
        return (
            <div className="card-begin-description">
                <div className="card-begin-name">
                    {isVacant
                        ? (CHALLENGE.beginTeamDashboard?.vacantSlotTitle)
                        : userName}
                </div>
                
                <div className="card-begin-number">{userId ? `#${userId}` : ''}</div>
                
            </div>
        )
    }

    const renderCardStats = () => {
        return (
            <div className="card-begin-stats-details">
                <div className="card-begin-stats-details-left">
                    <div className="card-begin-stats-details-label">
                        {CHALLENGE.beginTeamDashboard?.healthspanScoreTitle}
                    </div>
                    <div className="card-begin-stats-details-value">{healthspanScore ?? 0}</div>
                    <div className="card-begin-stats-details-caption">
                        {CHALLENGE.beginTeamDashboard?.healthspanScoreCaption}
                    </div>
                </div>
                <hr className="rounded-dividing-line"></hr>
                <div className="card-begin-stats-details-right">
                    <div className="card-begin-stats-details-label">
                        {CHALLENGE.beginTeamDashboard?.scoreEarnedTitle}
                    </div>
                    <div className="card-begin-stats-details-value">{remainingScore ?? 0}</div>
                    <div className="card-begin-stats-details-caption">
                        {CHALLENGE.beginTeamDashboard?.scoreEarnedCaption}
                    </div>
                </div>
            </div>
        )
    }

    const renderCardProgress = () => {
        return (
            <div className="card-begin-progress-details">
                <span className="card-begin-progress-label">
                    {CHALLENGE.beginTeamDashboard?.accumulatedScoreTitle}
                </span>
                <ProgressBar
                    value={scoreEarned ?? 0}
                    maxValue={BEGIN_MEMBER_SCORE_TARGET}
                />
            </div>
        )
    }

    return (
        <div className="user-begin-carousel">
            <div className={`card-begin-container-info`}>
                <ChallengeProfileImage
                    pictureUrl={pictureUrl || '/images/challenge/default_challenge_profile.svg'}
                    isLeader={isLeader}
                />
                {renderCardDescription()}
                {renderCardStats()}
                {renderCardProgress()}
            </div>
        </div>
    )
}

export default TeamBeginMemberCard;